import React from "react";
import { Routes, Route } from "react-router-dom";
import "./App.css";

// Components
import Header7 from "./components/Header7";
import Footer7 from "./components/Footer7";

// Pages
import Home7 from "./pages/Home7";
import Pricing from "./pages/Pricing";
import Workout from "./pages/Workout";
import Gallery from "./pages/Gallery";
import Trainers from "./pages/Trainers";
import Contact from "./pages/Contact";
import Faqs from "./pages/Faqs";
import About from "./pages/About";
import Services from "./pages/Services";

function App() {
  return (
    <div className="App">

      <Header7 />

      <main>
        <Routes>
          <Route path="/" element={<Home7 />} />
          <Route path="/plans" element={<Pricing />} />
          <Route path="/workouts" element={<Workout />} />
          <Route path="/gallery" element={<Gallery />} />
          <Route path="/trainers" element={<Trainers />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/faqs" element={<Faqs />} />
          <Route path="/about" element={<About />} />
          <Route path="/services" element={<Services />} />
        </Routes>
      </main>

      <Footer7 />

    </div>
  );
}

export default App;
